module.exports = __webpack_public_path__ + "images/27dd5c04f0e11a58f4c027de7b61286732dcecfaef8926d2fc5a8a7369b4d3fc.svg";